module.exports = __webpack_public_path__ + "img/carrousel-mamo-9.b2197d29.png";